const sortData = (rows, table) => {
	const sortingState = table.getState().sorting;

	// Filter out sortings that correspond to non existing columns
	const availableSorting = sortingState.filter((sort) =>
		table.getColumn(sort.id)?.getCanSort()
	);

	let columnInfoById = {};

	availableSorting.forEach((sortEntry) => {
		const column = table.getColumn(sortEntry.id);
		if (!column) return;

		columnInfoById[sortEntry.id] = {
			sortUndefined: column.columnDef.sortUndefined,
			invertSorting: column.columnDef.invertSorting,
			sortingFn: column.getSortingFn(),
		};
	});

	// This will also perform a stable sorting using the row index
	// if needed.
	const sortedData = rows.map((row) => ({ ...row }));

	sortedData.sort((rowA, rowB) => {
		for (let i = 0; i < availableSorting.length; i += 1) {
			const sortEntry = availableSorting[i];

			const columnInfo = sortEntry?.id ? columnInfoById[sortEntry?.id] : {};
			const isDesc = sortEntry?.desc || false;

			let sortInt = 0;

			// All sorting ints should always return in ascending order
			if (columnInfo.sortUndefined) {
				const aValue = rowA.getValue(sortEntry.id);
				const bValue = rowB.getValue(sortEntry.id);

				const aUndefined = aValue === undefined;
				const bUndefined = bValue === undefined;

				if (aUndefined || bUndefined) {
					sortInt =
						aUndefined && bUndefined
							? 0
							: aUndefined
							? columnInfo.sortUndefined
							: -columnInfo.sortUndefined;
				}
			}

			if (sortInt === 0) {
				sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
			}

			// If sorting is non-zero, take care of desc and inversion
			if (sortInt !== 0) {
				if (isDesc) {
					sortInt *= -1;
				}

				if (columnInfo.invertSorting) {
					sortInt *= -1;
				}

				return sortInt;
			}
		}

		return rowA.index - rowB.index;
	});

	return sortedData;
};

export { sortData };
